const style = {
  main: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      p: 2,
    },
  },
  icon: {
    fontSize: 'small',
  },
  box: {
    sx: {
      flexGrow: 1,
      ml: 3,
    },
  },
} as const;

export default style;
